import type { ReactNode } from 'react';
import { cn } from './cn';

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

/** Centered placeholder for empty feeds/tables. */
export function EmptyState({ title, description, icon, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 py-10 text-center', className)}>
      {icon ? <div className="text-ink-500">{icon}</div> : null}
      <p className="text-sm font-medium text-slate-100">{title}</p>
      {description ? <p className="max-w-sm text-xs text-text-secondary">{description}</p> : null}
    </div>
  );
}
